import type {
  AdminCatalogMediaListInput,
  AdminCatalogMediaSummary,
  AttachCatalogMediaInput,
  CatalogMediaOwnerMutationResult,
  CatalogMediaUploadInitiation,
  DetachCatalogMediaInput,
  InitiateCatalogMediaUploadInput,
  PaginatedResult,
} from '@emazy/shared-types';

export interface AdminCatalogMediaApi {
  initiate(input: InitiateCatalogMediaUploadInput): Promise<CatalogMediaUploadInitiation>;
  list(
    input: AdminCatalogMediaListInput,
    signal?: AbortSignal,
  ): Promise<PaginatedResult<AdminCatalogMediaSummary>>;
  get(id: string, signal?: AbortSignal): Promise<AdminCatalogMediaSummary>;
  retry(id: string): Promise<AdminCatalogMediaSummary>;
  delete(id: string): Promise<AdminCatalogMediaSummary>;
  attach(id: string, input: AttachCatalogMediaInput): Promise<CatalogMediaOwnerMutationResult>;
  detach(id: string, input: DetachCatalogMediaInput): Promise<CatalogMediaOwnerMutationResult>;
}

export class CatalogMediaClientError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status?: number,
  ) {
    super(message);
    this.name = 'CatalogMediaClientError';
  }
}
